import { gql } from "@apollo/client";
import { DEDUCTION_FRAGMENT } from "./deductionFragment";

const UPDATE_DEDUCTION_DETAILS = gql`
  ${DEDUCTION_FRAGMENT}
  mutation UpdateDeductionDetails($params: UpdateDeductionDetailsParams!) {
    updateDeductionDetails(params: $params) {
      ...DeductionFields
    }
  }
`;

export default UPDATE_DEDUCTION_DETAILS;
